import React, { Component } from "react";
import ReactDOM from "react-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import {
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBBtn
} from "mdbreact";

export class MyModal extends Component {
    
    // toggleModal = () => {
    //     this.setState({
    //       modal: !this.state.modal
    //     });
    //   };

    handleInputChange = inputName => value => {
        this.setState({
          [inputName] : value
        });
        // console.log(this.state);
      };
     
      onClose = e => {
        this.props.onClose && this.props.onClose(e);
      };
    
    addEvent = () => {
      var newArray=[...this.props.events];
      newArray.push({
        id: newArray.length > 0 ? newArray[newArray.length - 1].id + 1 : 1,
        time: this.state.time,
        title: this.state.title,
        location: this.state.location,
        description: this.state.description
       });
    this.setState({events : newArray});
    // this.setState({modal : false});

    this.setState({
        time: "",
        title: "",
        location: "",
        description: ""
    });

    this.onClose();


    }

      

  render() {
    return (
      <MDBModal events={this.props.events} isOpen={this.props.isOpen} toggle={this.props.toggle}
      >
        <MDBModalHeader
          className="text-center"
          titleClass="w-100 font-weight-bold"
          toggle={this.props.toggle}
        >
          Add new event
        </MDBModalHeader>
        <MDBModalBody>
            <MDBInput
                name="time"
                label="Time"
                icon="clock"
                hint="12:30"
                group type = "text"
                getValue={this.handleInputChange("time")}
            />
            <MDBInput 
                name="title"
                lable="Title"
                icon="edit"
                hint="Briefing"
                group type="text"
                getValue={this.handleInputChange("title")}
            />
        </MDBModalBody>
        <MDBModalFooter className="justify-content-center" >
        <MDBBtn color="info"
         onClick={
        this.addEvent
        
      } >
                Add
            </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    );
  }
}
